export default __webpack_public_path__ + "static/media/ep2collage4.8668613a.jpg";